import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/comisionCoordinadorAdministrativo";
import { PostProcesarExcel } from "../../../reducers/comisionCoordinadorAdministrativo";

export interface GeneracionCoordinadorAdministrativoDispatcher {
  procesarExcel: (
    formData: FormData,
    periodo: string,
    confirmacion: boolean
  ) => Promise<Preview<PostProcesarExcel>>;
  clearState: () => void;
}

export const generacionCoordinadorAdministrativoDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => GeneracionCoordinadorAdministrativoDispatcher = dispatch => ({
  procesarExcel: (
    formData: FormData,
    periodo: string,
    confirmacion: boolean
  ) => {
    return dispatch(actions.procesarExcel(formData, periodo, confirmacion));
  },
  clearState: () => {
    return dispatch(actions.clearComisiones());
  }
});
